module.exports = __webpack_public_path__ + "6df4e5d7.svg";